import React, { useEffect } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Icon } from '@iconify/react';
import "../inputsGlobals.css"
import "./styles.css"
import { useTranslation } from 'react-i18next';
import { Block, CRRender, Inline } from '@comp/crRender';

const safeDate = (date) => {
  if (!date) return null
  const d = new Date(date)
  return isNaN(d.getTime()) ? null : d
}

const getMinDate = (year) => {
  return new Date(year, 0, 1)
}

const getMaxDate = (year) => {
  return new Date(year, 11, 31)
}

const DatePickerC = ({
  minDate = new Date().getFullYear(),
  maxDate = new Date().getFullYear(),
  disabled,
  isRequired = true,
  className,
  formHandler,
  name,
  isSingle,
  defaultValue,
  label = null,
  type="date"
}) => {

  const { t } = useTranslation()
  const { formValues, handleFormValues, errors } = formHandler

  const fieldValue = formValues?.[name]?.value

  const Apply = (dateValue, options = {}) => {
    handleFormValues(name, {
      value: dateValue,
      isRequired,
      isError: false
    }, options)
  }

 
  useEffect(() => {
    Apply(isSingle ? null : { from: null, to: null }, { markAsTouched: false })
  }, [])

  
  useEffect(() => {
    if (defaultValue) {
      Apply(defaultValue, { markAsTouched: false })
    }
  }, [defaultValue])


  useEffect(() => {
    if(!isSingle){
      type = "dateRange"
    }
  }, [type,isSingle])


  return (
    <div className={`DatePickerContainer form-group col-md-4 ${className}`}>
      <Block isRender={name && !label} className={"col-sm-12 default-label"}>
        <div className="d-flex ">
          <label>{t(name)}</label>
          <Inline isRender={isRequired} className={"required"}>*</Inline>
        </div>
      </Block>

      <Block isRender={label} className={"col-sm-12 default-label"}>
        <div className='d-flex '>
          <label>{t(label)}</label>
          <Inline isRender={isRequired} className={"required"}>*</Inline>
        </div>
      </Block>

      <div className={`DatePicker ${formValues?.[name]?.isError ? "field-required" : ""}`}>
        <DatePicker
          showIcon
          icon={<Icon icon="ci:calendar-days" className='DateIcon' />}
          className={`dateInput ${formValues?.[name]?.isError ? "field-error" : ""}`}
          toggleCalendarOnIconClick
          selectsRange={!isSingle}
          placeholderText={`${t('please-enter')} ${t(label || name)}`}
          showYearDropdown
          yearDropdownItemNumber={50}
          scrollableYearDropdown
          allowIconClick={false}
          disabled={disabled}
          dateFormat="dd/MM/yyyy"
          selected={isSingle ? safeDate(fieldValue) : null}
          startDate={!isSingle ? safeDate(fieldValue?.from) : null}
          endDate={!isSingle ? safeDate(fieldValue?.to) : null}
          minDate={getMinDate(minDate)}
          maxDate={getMaxDate(maxDate)}
          onChange={(d) => {
            Apply(isSingle ? safeDate(d) : { from: safeDate(d?.[0]), to: safeDate(d?.[1]) })
          }}
        />
        <CRRender isRender={errors && errors[name]} className={""}>
          <p className="error-message">{errors?.[name]?.errorMessage}</p>
        </CRRender>
      </div>
    </div>
  )
}

export default DatePickerC
